export default __webpack_public_path__ + "static/media/icon-valor.143cd21d.svg";